import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh', background: '#060d18', display: 'flex',
        alignItems: 'center', justifyContent: 'center', padding: 24,
      }}>
        <div style={{ maxWidth: 480, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16, color: '#f87171' }}>!</div>
          <h2 style={{ color: '#e2e8f0', fontWeight: 700, fontSize: '1.3rem', marginBottom: 10 }}>
            Something went wrong
          </h2>
          <p style={{ color: '#94a3b8', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
            An unexpected error occurred. Try refreshing the page. If the problem persists, please report it using the feedback button.
          </p>
          {this.state.error?.message && (
            <pre style={{
              background: '#0a1120', border: '1px solid #1e293b', borderRadius: 6,
              padding: '10px 14px', color: '#f87171', fontSize: 12, textAlign: 'left',
              overflow: 'auto', maxHeight: 120, marginBottom: 24,
            }}>
              {this.state.error.message}
            </pre>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#f43f5e', border: 'none', borderRadius: 6, color: '#fff',
              fontWeight: 600, fontSize: 14, padding: '10px 24px', cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
}
